module.exports = __webpack_public_path__ + "static/media/test.74e8ac00.png";